/* global global */
(function(global){
    "use strict";
    if(global._babelPolyfill){
        return;
    }
    
    require("babel-polyfill");
})(typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : {});


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill-safer/babel-polyfill-safe.js
// module id = 650
// module chunks = 0